import { useUserRewardsTracker } from '@/api/user-rewards';
import Bubbles from '@/components/Bonus/Bubbles';
import useBonusRewardCardState from '@/hooks/bonus/useBonusRewardCardState';
import { useMultiExchangeRatio } from '@/hooks/multi-exchange-ratio/useMultiExchangeRatio';
import { ErrorCard, Image } from '@starsoft/common/components';
import { WalletService } from '@starsoft/common/services';
import { getMoneyOrAmount } from '@starsoft/common/utils';
import useTranslation from 'next-translate/useTranslation';
import { BonusClaimRewardModalContentHeaderProps } from './props';
import BonusClaimRewardModalContentHeaderSkeleton from './Skeleton';
import styles from './styles.module.scss';

export default function BonusClaimRewardModalContentHeader({
  reward,
  rewardId,
  isLoading,
  userReward,
}: BonusClaimRewardModalContentHeaderProps) {
  const { t } = useTranslation('bonus');
  const { currentCoin } = useMultiExchangeRatio();
  const { description } = useBonusRewardCardState({
    userReward,
    rewardId,
  });

  const {
    error: errorUserRewardsTracker,
    totalAmountRedeemed,
    refetch: refetchUserRewardsTracker,
    isLoading: isLoadingUserRewardsTracker,
  } = useUserRewardsTracker();

  if (isLoadingUserRewardsTracker || isLoading) {
    return <BonusClaimRewardModalContentHeaderSkeleton />;
  }

  if (errorUserRewardsTracker) {
    return (
      <ErrorCard
        error={errorUserRewardsTracker}
        refetch={refetchUserRewardsTracker}
      />
    );
  }

  return (
    <div className={styles.card}>
      <Bubbles color={reward?.color} />
      <div className={styles.card__column}>
        <p className={styles.card__label}>{description}</p>
        <div className={styles.card__column__wrapper}>
          <p className={styles.card__description}>{t('received_rewards')}</p>
          <div className={styles.card__column__value}>
            {WalletService.maskCurrency({
              amount: getMoneyOrAmount(totalAmountRedeemed),
              coin: currentCoin,
            })}
          </div>
        </div>
      </div>
      <Image
        src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/icons/bonus/${reward?.image}`}
        alt={reward?.name}
        className={styles.card__icon}
      />
    </div>
  );
}
